// layouts/FrontLayout.jsx
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../Components/template/Header';
import Footer from '../Components/template/Footer';

const FrontLayout = () => {
  const location = useLocation();
  
  return (
    <div className="flex flex-col min-h-screen main-layout-container">
      <Header />
      <main className="flex-grow flex flex-col ">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default FrontLayout;
